import { render, staticRenderFns } from "./usager-autocomplete.vue?vue&type=template&id=245dea0c&scoped=true"
import script from "./usager-autocomplete.vue?vue&type=script&lang=js"
export * from "./usager-autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245dea0c",
  null
  
)

export default component.exports